import { useMemo } from "react";

import { ScenarioData } from "pages/app/scenario-analysis/types/scenario";
import { buildDifferenceSeries } from "pages/app/scenario-analysis/utils/differenceView";
import { SoilSightOutcomesByScenario, scenarioLineColor } from "pages/app/scenario-analysis/utils/forecast";
import { resolveComparisonSelection } from "pages/app/scenario-analysis/utils/scenarioComparison";

type DifferenceViewArgs = {
  scenarios: ScenarioData[];
  projectionYears: number;
  soilSightOutcomes: SoilSightOutcomesByScenario | null;
  comparisonScenarioId: string | null;
};

/** The Difference view's scenario pair (baseline vs the one key insights selected) and its year-by-year gap. */
export const useDifferenceView = ({ scenarios, projectionYears, soilSightOutcomes, comparisonScenarioId }: DifferenceViewArgs) => {
  const {
    baseline: differenceBaseline,
    selected: differenceComparison,
    comparisonScenarios,
  } = useMemo(() => resolveComparisonSelection(scenarios, comparisonScenarioId), [scenarios, comparisonScenarioId]);

  const differenceSeries = useMemo(() => {
    if (!differenceBaseline || !differenceComparison) return [];
    return buildDifferenceSeries(soilSightOutcomes?.[differenceComparison.id] ?? [], soilSightOutcomes?.[differenceBaseline.id] ?? [], projectionYears);
  }, [soilSightOutcomes, differenceBaseline, differenceComparison, projectionYears]);

  return {
    hasDifferenceView: Boolean(differenceBaseline && differenceComparison),
    differenceBaseline,
    differenceComparison,
    comparisonScenarioCount: comparisonScenarios.length,
    differenceSeries,
    differenceLineColor: scenarioLineColor(scenarios, differenceComparison?.id),
  };
};
